import {ADD_PRODUCT, INCREASE_PRODUCT_QTY, DECREASE_PRODUCT_QTY, RESTORE_PRODUCT_QTY} from "./actionTypes";

export const addProduct = (product) => {
    return {
        type: ADD_PRODUCT,
        payload: product,
    }
}

export const increaseProductQuantity = (productId) => {
    return {
        type: INCREASE_PRODUCT_QTY,
        payload: productId
    }
}

export const decreaseProductQuantity = (productId) => {
    return {
        type: DECREASE_PRODUCT_QTY,
        payload: productId
    }
}

export const restoreProductQuantity = (productId, quantityToRestore) => {
    return {
        type: RESTORE_PRODUCT_QTY,
        payload: {
            id: productId,
            quantity: quantityToRestore
        }
    }
}